import terminalService from '@/api/terminal.js';
import backofficeService from '@/api/backoffice.js';

export default {
  /**
   * Get list of employees for a location
   * @param {*} locationCode the location's unique code
   */
  /**
   * Send forgot password email
   * @param {*} params Query Options
   */
  forgetPassword(data) {
    return backofficeService.Api().post('auth/forget', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  async getLocation(locationCode) {
    if (!locationCode)
      locationCode = await localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`);
    return terminalService
      .Api()
      .post('', { code: locationCode })
      .then(response => {
        // console.log('responseresponse', response)
        localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`, response.data.data.code);
        return response.data;
      })
      .catch(error => {
        console.log('error getLocation', error)
        throw error;
      });
  },
  /**
   *  Get token from server
   * @param {} id
   * @param {*} pin
   * @param {*} locationCode
   * @param {*} deviceCode
   * @param {*} deviceName
   */
  authenticate(params, temp) {
    return terminalService
      .Api()
      .post('token', {
        id: params.id,
        pinCode: params.pin,
        code: params.locationCode,
        deviceCode: params.deviceCode,
        deviceName: params.deviceName,
      })
      .then(response => {
        if (!temp) {
          localStorage.setItem(
            `${process.env.VUE_APP_STORAGE_PREFIX}token`,
            response.data.data.token,
          );
        }
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  },
  /**
   * Returns any infomation saved in the local storage about the device.
   * If there is nothing saved, you will still get a newly generated device code
   */
  getStoredDevice() {
    return {
      deviceName: localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}deviceName`),
      deviceCode:
        localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}deviceCode`) ||
        this.randomString(
          25,
          '1234567890ABCDEFGHIJKLMNOPQURSTUVWXYZ[]abcdefghijklmnopqurstuvwxyz#$%_(){}!/*-+',
        ),
    };
  },
  randomString(length, chars) {
    let result = '';
    for (let i = length; i > 0; --i) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
  },
  /**
   * Set this device's information
   * @param {*} code location code
   * @param {*} deviceName
   * @param {*} deviceCode
   */
  setDevice(code, deviceName, deviceCode) {
    localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`, code);
    localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}deviceName`, deviceName);
    localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}deviceCode`, deviceCode);
    console.log('set code');
    try {
      window.postMessage({
        action: 'SETCODE',
        data: code,
      });
    } catch (error) {
      console.log(error);
    }
	},
	
	setLastEmployeeId(lastEmployeeId) {
		localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}lastEmployeeId`, lastEmployeeId);
	},
  /**
   * Remove the location code store if there exist one/
   */
  resetLocationCode() {
    localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}cashDrawerId`);
    return localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`);
  },
  submit(data) {
    return backofficeService.Api().post('signup', data)
      .then((response) => {
        // localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`, response.data.data)
        return response.data
      })
      .catch((error) => { throw error })
  },
  /**
   * Submit user token for verification
   * @param {*} params Query Options
   */
  verify(data) {
    return backofficeService.Api().post('signup/verifyEmail', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Resubmit email
   * @param {*} params Query Options
   */
  resendVerifyEmail(data) {
    return backofficeService.Api().post('signup/resendVerification', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
};
